import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-icon-renderer',
  template: `
    <div (click)="onClick($event)">
      <i class="fa fa-download pointer"></i>
    </div>
    `
})

export class IconRendererComponent implements ICellRendererAngularComp {
  params;
  label: string;

  constructor() {}

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowNode: this.params.node,
        rowIndex: this.params.rowIndex,
      }
      this.params.onClick(params);

    }
  }
}
